import React from 'react';
import { Dialog } from 'primereact/dialog';

import "./hubIntegrationsMenu.scss"
import upload from "../../../assets/images/integrationIcons/icones/Importacao.png"
import nfePNG from "../../../assets/images/integrationIcons/icones/SEFAZ.png"
import cloud from "../../../assets/images/integrationIcons/icones/API.png"
import edi from "../../../assets/images/integrationIcons/icones/EDI.png"
import ImportFilesFormPageContainer from '../../importfiles/form/ImportFilesFormPageContainer';

export const HubIntegrationsMenu = (props) => {
    let dotColorCte = "silver"
    let dotColorNfeSaida = "silver"
    let dotColorNfeEntrada = "silver"
    let dotcolorGeral = "silver"

    if (props?.logCte?.records?.length >= 0 && props?.logCte?.records[0]?.status === "OK") {
        dotColorCte = "green"
    } else if (props?.logCte?.records?.length >= 0 && props?.logCte?.records[0]?.status === "ERRO") {
        dotColorCte = "red"
    }

    if (props?.currentRecord?.statusNfeSaida === "OK") {
        dotColorNfeSaida = "green"
    } else if (props?.currentRecord?.statusNfeSaida === "ERRO") {
        dotColorNfeSaida = "red"
    }

    if (props?.logNfe?.records?.length >= 0 && props?.logNfe?.records[0]?.status === "OK") {
        dotColorNfeEntrada = "green"
    } else if (props?.logNfe?.records?.length >= 0 && props?.logNfe?.records[0]?.status === "ERRO") {
        dotColorNfeEntrada = "red"
    }

    if (dotColorCte === "red" || dotColorNfeSaida === "red" || dotColorNfeEntrada === "red") {
        dotcolorGeral = "red"
    } else if (dotColorCte === "green" || dotColorNfeSaida === "green" || dotColorNfeEntrada === "green") {
        dotcolorGeral = "green"
    }

    return (
        <div className="p-grid" style={{ marginTop: "20px" }}>
            <div className="p-col-3 form-field-container">
                <button className={`lognex-btn-highlighted-inverse custom-button ${props?.module?.sefaz ? "active" : "inactive"}`}
                    onClick={props.enableSefazModuleHandler}
                >
                    <span className="button-label">SEFAZ</span>
                    <div className="button-content">
                        <img src={nfePNG} alt="NFe" className="icon-nfe" />
                    </div>
                    <span className={`notification-dot ${dotcolorGeral}`} style={{ zIndex: 10 }} />
                </button>
            </div>

            <div className="p-col-3 form-field-container">
                <button className={`lognex-btn-highlighted-inverse custom-button ${props?.module?.api ? "active" : "inactive"}`}
                    // onClick={() => window.open("https://tms.lognex.com.br/docs/", "_blank")}
                    onClick={props.enableApiModuleHandler}
                >
                    <span className="button-label">API'S</span>
                    <div className="button-content">
                        <img src={cloud} alt="NFe" className="icon-api" />
                    </div>
                </button>
            </div>
            {/* <div className="p-col-3 form-field-container">
                <button className={`lognex-btn-highlighted-inverse custom-button ${props?.module?.edi ? "active" : "inactive"}`}
                    onClick={() => window.open("https://tms.lognex.com.br/docs/", "_blank")}
                >
                    <span className="button-label">EDI's</span>
                    <div className="button-content">
                        <img src={edi} alt="NFe" className="icon-edi" />
                    </div>
                </button>
            </div> */}
            <div className="p-col-3 form-field-container">
                <button className={`lognex-btn-highlighted-inverse custom-button ${props?.module?.manual ? "active" : "inactive"}`}
                    onClick={props.enableManualModuleHandler}
                >
                    <span className="button-label-manual">Importação Manual</span>
                    <div className="button-content">
                        <img src={upload} alt="NFe" className="icon-importacao" />
                    </div>
                </button>
            </div>

            {/* <Dialog
                header={
                    <div className="lxButtonDialogHeader">
                        <div className="lxHeaderTitle">
                            <h3>{props.dialogManualImport.header}</h3>
                        </div>
                        <button
                            className="p-dialog-titlebar-icon p-link lxHeaderClose"
                            onClick={props.hideDialogManualImport}
                        >
                            <span className="pi pi-times"></span>
                        </button>
                    </div>
                }
                closable={false}
                visible={props.dialogManualImport.visible}
                modal={props.dialogManualImport.modal}
                onHide={props.hideDialogManualImport}
            >
                <ImportFilesFormPageContainer
                />
            </Dialog> */}
        </div>
    );
}
